import { useNavigate, useLocation } from 'react-router-dom';
import Icons, { allLayout as allLayoutIcon, help as helpIcon, menuClose, menuOpen } from "./Icons"
import {__} from '@wordpress/i18n';
import { useState } from 'react';

export default function Sidebar() {
    const navigate = useNavigate();
    const location = useLocation();
    const [menuCollapsed, setMenuCollapsed] = useState(false);

    return (
        <div className="responsive-site-builder-sidebar py-8 pl-10">
            { ! menuCollapsed && 
                    <div className="bg-white text-[14px] rounded-md min-w-[190px] shadow-[0_0_14px_0_#014B7126] p-3">
                        {/* Collapse Button */}
                        <button className="flex justify-between items-center text-black gap-2.5" onClick={()=>setMenuCollapsed( (menuCollapsed)=> ! menuCollapsed )}>
                            {menuClose}{__('Collapse', 'responsive-addons')}
                        </button>
                        {/* All Layouts Link */}
                        <div
                        className={`flex gap-[14px] items-center py-5 mt-[18px] mb-2.5 border-y-[1px] border-border cursor-pointer hover:text-btnPrimary ${
                            location.pathname === '/' || location.pathname === '/new'
                            ? 'text-btnPrimary'
                            : 'text-black'
                        }`}
                        onClick={() => navigate(`/`)}
                        >
                        {allLayoutIcon}
                        <span
                            className={`leading-6 hover:text-btnPrimary ${
                            location.pathname === '/' || location.pathname === '/new'
                                ? 'text-btnPrimary' : '' }`}
                        >
                            {__('All Layouts', 'responsive-addons')}
                        </span>
                        </div>
                        {/* Icon Menu List */}
                        <div>
                        {Icons.map((icon) => {
                            const isActive = location.pathname === `/${icon.layout}`;
                            return (
                            <div
                                key={icon.layout}
                                className={`flex gap-[14px] items-center py-3 cursor-${
                                icon.comingSoon ? 'not-allowed' : 'pointer'
                                } ${icon.comingSoon ? 'opacity-70' : 'hover:text-btnPrimary'} ${
                                isActive ? 'text-btnPrimary' : 'text-black'
                                }`}
                                onClick={
                                !icon.comingSoon ? () => navigate(`/${icon.layout}`) : undefined
                                }
                            >
                                <span>{icon.icon}</span>
                                <span className={`font-normal leading-6 ${ isActive ? 'text-btnPrimary' : '' }`}> {icon.label} </span>

                                {icon.comingSoon && (
                                    <span className="ml-auto inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-yellow-600/20 ring-inset">
                                        {__('Coming Soon', 'responsive-addons')}
                                    </span>
                                )}
                            </div>
                            );
                        })}
                        </div>
                    </div>
            }
            { menuCollapsed &&
                    <div className="flex flex-col items-center bg-white text-[12px] rounded-md min-w-[44px] shadow-[0_0_14px_0_#014B7126]">
                        {/* Collapse Button */}
                        <button className="text-black gap-2.5 pt-3" onClick={()=>setMenuCollapsed( (menuCollapsed)=> ! menuCollapsed )}>
                            {menuOpen}
                        </button>
                        {/* All Layouts Link */}
                        <div
                        className={`relative group py-5 px-3 mt-5 mb-2.5 border-y-[1px] border-border cursor-pointer hover:text-btnPrimary ${
                            location.pathname === '/' || location.pathname === '/new'
                            ? 'text-btnPrimary'
                            : 'text-black'
                        }`}
                        onClick={() => navigate(`/`)}
                        >
                            {allLayoutIcon}
                            <span className='hidden absolute left-full ml-2 top-1/2 -translate-y-1/2 group-hover:block whitespace-nowrap bg-white text-btnPrimary px-2 py-1 rounded shadow-md duration-200 z-10'> {__('All Layouts', 'responsive-addons')} </span>
                        </div>
                        {/* Icon Menu List */}
                        <div>
                        {Icons.map((icon) => {
                            const isActive = location.pathname === `/${icon.layout}`;
                            return (
                                !icon.comingSoon && (
                                    <div
                                    key={icon.layout}
                                    className={`relative flex items-center justify-center py-3 group cursor-pointer ${
                                        isActive ? 'text-btnPrimary' : 'text-black'
                                    } hover:text-btnPrimary`}
                                    onClick={() => navigate(`/${icon.layout}`)}
                                    >
                                    <span>{icon.icon}</span>

                                    <span
                                        className="hidden absolute left-full ml-5 top-1/2 -translate-y-1/2 group-hover:block whitespace-nowrap
                                                bg-white text-btnPrimary px-2 py-1 rounded shadow-md
                                                duration-200 z-10"
                                    >
                                        {icon.label}
                                    </span>
                                    </div>
                                )
                            );
                        })}
                        </div>
                    </div>
            }
            <div
                className="fixed bottom-6 right-10 z-50 group cursor-pointer"
                onClick={() => window.open(responsive_addons_site_builder.docsPageURL, "_blank")}
                >
                {/* Tooltip */}
                <div className="absolute bottom-14 left-1/2 -translate-x-1/2 hidden group-hover:flex flex-col items-center">
                    <div className="text-[12px] bg-white text-black rounded-md px-2.5 py-1.5 shadow-[0px_4px_8px_0px_#0000001F]">
                    {__('Help', 'responsive-addons')}
                    </div>
                    {/* Arrow */}
                    <div className="w-2 h-2 bg-white rotate-45 -mt-1 shadow-[0px_4px_8px_0px_#0000001F]"></div>
                </div>
                {/* Circle Help Icon */}
                <div className="flex justify-center items-center w-12 h-12 rounded-full bg-white border border-border">
                    {helpIcon}
                </div>
            </div>
        </div>
    )
}